export default __webpack_public_path__ + "static/media/fillrock-kd-plus_comp.393f9f50.jpg";